import React from 'react';
import { ResourceUtilization } from '@bryntum/schedulerpro';
import { createWidget, shouldComponentUpdate } from './WrapperHelper.js';
export class BryntumResourceUtilization extends React.Component {
    constructor() {
        super(...arguments);
        this.portalContainerClass = 'b-react-portal-container';
        this.state = {
            portals: new Map(),
            generation: 0
        };
        this.featureNames = [
            'calendarHighlightFeature',
            'cellEditFeature',
            'cellMenuFeature',
            'cellTooltipFeature',
            'columnAutoWidthFeature',
            'columnDragToolbarFeature',
            'columnLinesFeature',
            'columnPickerFeature',
            'columnReorderFeature',
            'columnResizeFeature',
            'dependenciesFeature',
            'dependencyEditFeature',
            'eventBufferFeature',
            'eventCopyPasteFeature',
            'eventDragFeature',
            'eventDragCreateFeature',
            'eventDragSelectFeature',
            'eventEditFeature',
            'eventFilterFeature',
            'eventMenuFeature',
            'eventResizeFeature',
            'eventTooltipFeature',
            'excelExporterFeature',
            'filterFeature',
            'filterBarFeature',
            'groupFeature',
            'groupSummaryFeature',
            'headerMenuFeature',
            'headerZoomFeature',
            'labelsFeature',
            'mergeCellsFeature',
            'multipageFeature',
            'multipageverticalFeature',
            'nonWorkingTimeFeature',
            'panFeature',
            'pdfExportFeature',
            'percentBarFeature',
            'quickFindFeature',
            'regionResizeFeature',
            'resourceNonWorkingTimeFeature',
            'resourceTimeRangesFeature',
            'rowCopyPasteFeature',
            'rowReorderFeature',
            'scheduleContextFeature',
            'scheduleMenuFeature',
            'scheduleTooltipFeature',
            'searchFeature',
            'simpleEventEditFeature',
            'singlepageFeature',
            'sortFeature',
            'stickyCellsFeature',
            'stickyEventsFeature',
            'stripeFeature',
            'summaryFeature',
            'taskEditFeature',
            'timeAxisHeaderMenuFeature',
            'timeRangesFeature',
            'timeSpanHighlightFeature',
            'treeFeature',
            'treeGroupFeature'
        ];
        this.projectStores = false;
        this.dataStores = {
            'assignmentStore': 'assignments',
            'dependencyStore': 'dependencies',
            'eventStore': 'events',
            'resourceStore': 'resources',
            'resourceTimeRangeStore': 'resourceTimeRanges',
            'timeRangeStore': 'timeRanges'
        };
        this.configNames = [
            'adopt',
            'align',
            'allowCreate',
            'allowOver',
            'allowOverlap',
            'anchor',
            'anchorToTarget',
            'animateRemovingRows',
            'appendTo',
            'ariaDescription',
            'ariaLabel',
            'autoAdjustTimeAxis',
            'autoClose',
            'autoHeight',
            'autoShow',
            'autoUpdateRecord',
            'barTextEffortUnit',
            'barTipEffortUnit',
            'barTooltipTemplate',
            'bbar',
            'bodyCls',
            'bubbleEvents',
            'bufferCoef',
            'bufferThreshold',
            'callOnFunctions',
            'centered',
            'closable',
            'closeAction',
            'cls',
            'collapsed',
            'collapsible',
            'columns',
            'config',
            'constrainTo',
            'contentElementCls',
            'contextMenuTriggerEvent',
            'createEventOnDblClick',
            'creationTooltip',
            'crudManagerClass',
            'cycleResolutionPopupClass',
            'date',
            'defaultBindProperty',
            'defaultFocus',
            'defaultRegion',
            'defaultResourceImageName',
            'defaults',
            'dependencyIdField',
            'descriptionRenderer',
            'deselectOnClick',
            'destroyStore',
            'destroyStores',
            'disableGridRowModelWarning',
            'dismissDelay',
            'displaySchedulingIssueResolutionPopup',
            'dock',
            'draggable',
            'durationDisplayPrecision',
            'effortUnit',
            'emptyText',
            'enableDeleteKey',
            'enableEventAnimations',
            'enableRecurringEvents',
            'enableSticky',
            'enableTextSelection',
            'enableUndoRedoKeys',
            'endParamName',
            'eventBarTextField',
            'eventBodyTemplate',
            'eventRenderer',
            'eventRendererThisObj',
            'eventSelectionDisabled',
            'eventStyle',
            'features',
            'fillLastColumn',
            'fixedRowHeight',
            'floating',
            'focusOnToFront',
            'footer',
            'forceFit',
            'forElement',
            'forSelector',
            'fullRowRefresh',
            'getBarText',
            'getBarTip',
            'getDateConstraints',
            'getHtml',
            'getRectClass',
            'getRowHeight',
            'header',
            'hideAnimation',
            'hideDelay',
            'hideHeaders',
            'hideOnDelegateChange',
            'hideWhenEmpty',
            'highlightPredecessors',
            'highlightSuccessors',
            'horizontalEventSorterFn',
            'hoverDelay',
            'htmlCls',
            'includeInactiveEvents',
            'infiniteScroll',
            'insertBefore',
            'insertFirst',
            'itemCls',
            'lazyItems',
            'listeners',
            'loadingMsg',
            'loadMask',
            'loadMaskDefaults',
            'loadMaskError',
            'localeClass',
            'localizableProperties',
            'longPressTime',
            'maintainSelectionOnDatasetChange',
            'managedEventSizing',
            'maskDefaults',
            'masked',
            'maximizable',
            'maximized',
            'modal',
            'mode',
            'monitorResize',
            'mouseOffsetX',
            'mouseOffsetY',
            'multiEventSelect',
            'namedItems',
            'owner',
            'partner',
            'passStartEndParameters',
            'plugins',
            'positioned',
            'preCalculateHeightLimit',
            'preserveFocusOnDatasetChange',
            'preserveScrollOnDatasetChange',
            'preventTooltipOnTouch',
            'projectProgressReporting',
            'range',
            'relayStoreEvents',
            'removeUnassignedEvent',
            'resizeToFitIncludesHeader',
            'resourceColumns',
            'resourceImageExtension',
            'resourceImagePath',
            'responsiveLevels',
            'ripple',
            'rootElement',
            'schedulingIssueResolutionPopupClass',
            'scrollAction',
            'scrollerClass',
            'scrollManager',
            'selectionMode',
            'showAnimation',
            'showBarText',
            'showBarTip',
            'showCreationTooltip',
            'showDirty',
            'showMaxEffort',
            'showOnClick',
            'showOnHover',
            'showRecurringUI',
            'showTooltipWhenDisabled',
            'snapRelativeToEventStartDate',
            'startParamName',
            'stateful',
            'statefulEvents',
            'stateId',
            'stateProvider',
            'stepUnit',
            'stickyHeaders',
            'strips',
            'subGridConfigs',
            'suppressFit',
            'syncMask',
            'tab',
            'tag',
            'tbar',
            'terminalCls',
            'terminalSides',
            'textAlign',
            'textContent',
            'timeAxis',
            'title',
            'trackMouse',
            'trapFocus',
            'triggerSelectionChangeOnRemove',
            'ui',
            'verticalTimeAxisColumn',
            'visibleDate',
            'visibleZoomFactor',
            'weekStartDay',
            'weight',
            'zoomKeepsOriginalTimespan',
            'zoomOnMouseWheel',
            'zoomOnTimeAxisDoubleClick'
        ];
        this.propertyConfigNames = [
            'alignSelf',
            'allowDropOnEventBar',
            'assignments',
            'assignmentStore',
            'barMargin',
            'calendars',
            'columnLines',
            'content',
            'crudManager',
            'data',
            'dataset',
            'dependencies',
            'dependencyStore',
            'disabled',
            'displayDateFormat',
            'endDate',
            'eventColor',
            'eventLayout',
            'events',
            'eventStore',
            'extraData',
            'fillTicks',
            'flex',
            'height',
            'hidden',
            'html',
            'id',
            'items',
            'layout',
            'layoutStyle',
            'margin',
            'maxHeight',
            'maxWidth',
            'maxZoomLevel',
            'milestoneAlign',
            'milestoneCharWidth',
            'milestoneLayoutMode',
            'milestoneTextPosition',
            'minHeight',
            'minWidth',
            'minZoomLevel',
            'onAfterDependencyCreateDrop',
            'onAfterDependencySave',
            'onAfterDragCreate',
            'onAfterEventDrop',
            'onAfterEventSave',
            'onAfterTaskEdit',
            'onAfterTaskSave',
            'onAssignmentSelectionChange',
            'onBeforeAssignmentDelete',
            'onBeforeCellEditStart',
            'onBeforeColumnDragStart',
            'onBeforeColumnDropFinalize',
            'onBeforeCopy',
            'onBeforeDependencyAdd',
            'onBeforeDependencyCreateDrag',
            'onBeforeDependencyCreateFinalize',
            'onBeforeDependencyDelete',
            'onBeforeDependencyEdit',
            'onBeforeDependencyEditShow',
            'onBeforeDependencySave',
            'onBeforeDestroy',
            'onBeforeDragCreate',
            'onBeforeDragCreateFinalize',
            'onBeforeEventAdd',
            'onBeforeEventDelete',
            'onBeforeEventDrag',
            'onBeforeEventDropFinalize',
            'onBeforeEventEdit',
            'onBeforeEventEditShow',
            'onBeforeEventResize',
            'onBeforeEventResizeFinalize',
            'onBeforeEventSave',
            'onBeforeFinishCellEdit',
            'onBeforeHide',
            'onBeforePaste',
            'onBeforePdfExport',
            'onBeforePresetChange',
            'onBeforeRenderRow',
            'onBeforeRenderRows',
            'onBeforeSetRecord',
            'onBeforeShow',
            'onBeforeTaskDelete',
            'onBeforeTaskEdit',
            'onBeforeTaskEditShow',
            'onBeforeTaskSave',
            'onBeforeToggleNode',
            'onCancelCellEdit',
            'onCatchAll',
            'onCellClick',
            'onCellContextMenu',
            'onCellDblClick',
            'onCellMenuBeforeShow',
            'onCellMenuItem',
            'onCellMenuShow',
            'onCellMenuToggleItem',
            'onCellMouseOut',
            'onCellMouseOver',
            'onCollapseNode',
            'onColumnDragStart',
            'onColumnDrop',
            'onContextMenuItem',
            'onContextMenuToggleItem',
            'onCopy',
            'onDataChange',
            'onDateRangeChange',
            'onDependencyClick',
            'onDependencyCreateDragStart',
            'onDependencyCreateDrop',
            'onDependencyDblClick',
            'onDependencyMouseOut',
            'onDependencyMouseOver',
            'onDependencyValidationComplete',
            'onDependencyValidationStart',
            'onDestroy',
            'onDragCreateEnd',
            'onDragCreateStart',
            'onEventAutoCreated',
            'onEventClick',
            'onEventContextMenu',
            'onEventDblClick',
            'onEventDrag',
            'onEventDragAbort',
            'onEventDragReset',
            'onEventDragStart',
            'onEventDrop',
            'onEventEditBeforeSetRecord',
            'onEventKeyDown',
            'onEventKeyUp',
            'onEventMenuBeforeShow',
            'onEventMenuItem',
            'onEventMenuShow',
            'onEventMouseDown',
            'onEventMouseOut',
            'onEventMouseOver',
            'onEventMouseUp',
            'onEventPartialResize',
            'onEventResizeEnd',
            'onEventResizeStart',
            'onEventSelectionChange',
            'onExpandNode',
            'onFinishCellEdit',
            'onFocusIn',
            'onFocusOut',
            'onHeaderMenuBeforeShow',
            'onHeaderMenuItem',
            'onHeaderMenuShow',
            'onHeaderMenuToggleItem',
            'onHide',
            'onMouseOut',
            'onMouseOver',
            'onNavigate',
            'onPaint',
            'onPaste',
            'onPdfExport',
            'onPresetChange',
            'onReadOnly',
            'onReleaseEvent',
            'onRenderEvent',
            'onRenderRow',
            'onRenderRows',
            'onResize',
            'onResourceHeaderClick',
            'onResourceHeaderContextmenu',
            'onResourceHeaderDblclick',
            'onResponsive',
            'onScheduleClick',
            'onScheduleContextMenu',
            'onScheduleDblClick',
            'onScheduleMenuBeforeShow',
            'onScheduleMenuItem',
            'onScheduleMenuShow',
            'onScheduleMouseMove',
            'onScroll',
            'onSelectionChange',
            'onShow',
            'onStartCellEdit',
            'onSubGridCollapse',
            'onSubGridExpand',
            'onTaskEditCanceled',
            'onTimeAxisChange',
            'onTimeAxisHeaderClick',
            'onTimeAxisHeaderContextMenu',
            'onTimeAxisHeaderContextMenuBeforeShow',
            'onTimeAxisHeaderContextMenuItem',
            'onTimeAxisHeaderContextMenuShow',
            'onTimeAxisHeaderDblClick',
            'onTimelineViewportResize',
            'onTimeRangeHeaderClick',
            'onTimeRangeHeaderContextMenu',
            'onTimeRangeHeaderDblClick',
            'onToggleNode',
            'onToolClick',
            'onVisibleDateRangeChange',
            'overlappingEventSorter',
            'presets',
            'project',
            'readOnly',
            'resourceMargin',
            'resources',
            'resourceStore',
            'resourceTimeRanges',
            'resourceTimeRangeStore',
            'rowHeight',
            'scrollable',
            'snap',
            'startDate',
            'store',
            'tickSize',
            'timeRanges',
            'timeRangeStore',
            'tools',
            'tooltip',
            'transitionDuration',
            'useInitialAnimation',
            'viewPreset',
            'width',
            'workingTime',
            'x',
            'y'
        ];
        this.propertyNames = [
            'anchorSize',
            'eventColors',
            'eventStyles',
            'isEngineReady',
            'isSettingValues',
            'isValid',
            'record',
            'scrollLeft',
            'scrollTop',
            'selectedAssignments',
            'selectedCell',
            'selectedEvents',
            'selectedRecord',
            'selectedRecords',
            'state',
            'timeResolution',
            'type',
            'values',
            'zoomLevel'
        ];
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        const className = `b-react-${BryntumResourceUtilization.instanceClass.$name.toLowerCase()}-container`;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: className, ref: (element) => (this.element = element) }, Array.from(this.state.portals).map((item) => item[1])),
            React.createElement("div", { ref: el => (this.portalsCache = el), className: "b-react-portals-cache", style: { display: 'none' } })));
    }
}
BryntumResourceUtilization.instanceClass = ResourceUtilization;
BryntumResourceUtilization.isView = true;
//# sourceMappingURL=BryntumResourceUtilization.js.map